import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

// P1 on desktop, P2 on mobile
export const Text = styled(P2)<any>`
  text-align: center;
  margin-top: ${({ hasTitle }) => (hasTitle ? '18px' : '0px')};

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize16};
    line-height: 26px;
    margin-top: ${({ hasTitle }) => (hasTitle ? '15px' : '0px')};
  }

  p {
    margin: 0px;
  }
`;
